import * as ambassadorWixBlogV3Post from './blog-v3-post-posts.http.js';
import * as ambassadorWixBlogV3PostTypes from './blog-v3-post-posts.types.js';
import * as ambassadorWixBlogV3PostUniversalTypes from './blog-v3-post-posts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryPostCountStats(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBlogV3PostUniversalTypes.QueryPostCountStatsRequest,
  ambassadorWixBlogV3PostTypes.QueryPostCountStatsRequest,
  ambassadorWixBlogV3PostUniversalTypes.QueryPostCountStatsResponse,
  ambassadorWixBlogV3PostTypes.QueryPostCountStatsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBlogV3Post.queryPostCountStats(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/stats/post/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTotalPosts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBlogV3PostUniversalTypes.GetTotalPostsRequest,
  ambassadorWixBlogV3PostTypes.GetTotalPostsRequest,
  ambassadorWixBlogV3PostUniversalTypes.GetTotalPostsResponse,
  ambassadorWixBlogV3PostTypes.GetTotalPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBlogV3Post.getTotalPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/stats/posts/total',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPost(): __PublicMethodMetaInfo<
  'GET',
  { postId: string },
  ambassadorWixBlogV3PostUniversalTypes.GetPostRequest,
  ambassadorWixBlogV3PostTypes.GetPostRequest,
  ambassadorWixBlogV3PostUniversalTypes.GetPostResponse,
  ambassadorWixBlogV3PostTypes.GetPostResponse
> {
  const payload = { postId: ':postId' } as any;

  const getRequestOptions = ambassadorWixBlogV3Post.getPost(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/posts/{postId}',
    pathParams: { postId: 'postId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPostBySlug(): __PublicMethodMetaInfo<
  'GET',
  { slug: string },
  ambassadorWixBlogV3PostUniversalTypes.GetPostBySlugRequest,
  ambassadorWixBlogV3PostTypes.GetPostBySlugRequest,
  ambassadorWixBlogV3PostUniversalTypes.GetPostBySlugResponse,
  ambassadorWixBlogV3PostTypes.GetPostBySlugResponse
> {
  const payload = { slug: ':slug' } as any;

  const getRequestOptions = ambassadorWixBlogV3Post.getPostBySlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/posts/slugs/{slug}',
    pathParams: { slug: 'slug' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listPosts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBlogV3PostUniversalTypes.ListPostsRequest,
  ambassadorWixBlogV3PostTypes.ListPostsRequest,
  ambassadorWixBlogV3PostUniversalTypes.ListPostsResponse,
  ambassadorWixBlogV3PostTypes.ListPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBlogV3Post.listPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/posts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPosts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBlogV3PostUniversalTypes.QueryPostsRequest,
  ambassadorWixBlogV3PostTypes.QueryPostsRequest,
  ambassadorWixBlogV3PostUniversalTypes.QueryPostsResponse,
  ambassadorWixBlogV3PostTypes.QueryPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBlogV3Post.queryPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/posts/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPostMetrics(): __PublicMethodMetaInfo<
  'GET',
  { postId: string },
  ambassadorWixBlogV3PostUniversalTypes.GetPostMetricsRequest,
  ambassadorWixBlogV3PostTypes.GetPostMetricsRequest,
  ambassadorWixBlogV3PostUniversalTypes.GetPostMetricsResponse,
  ambassadorWixBlogV3PostTypes.GetPostMetricsResponse
> {
  const payload = { postId: ':postId' } as any;

  const getRequestOptions = ambassadorWixBlogV3Post.getPostMetrics(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/posts/{postId}/metrics',
    pathParams: { postId: 'postId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Post as PostOriginal,
  PageUrl as PageUrlOriginal,
  PostCountInfo as PostCountInfoOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  Metrics as MetricsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  V1Media as V1MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  BannerOrigin as BannerOriginOriginal,
  BannerOriginWithLiterals as BannerOriginWithLiteralsOriginal,
  BannerPosition as BannerPositionOriginal,
  BannerPositionWithLiterals as BannerPositionWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  ModerationDetails as ModerationDetailsOriginal,
  ModerationStatusStatus as ModerationStatusStatusOriginal,
  ModerationStatusStatusWithLiterals as ModerationStatusStatusWithLiteralsOriginal,
  Media as MediaOriginal,
  MediaMediaOneOf as MediaMediaOneOfOriginal,
  WixMedia as WixMediaOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  EmbedMedia as EmbedMediaOriginal,
  EmbedThumbnail as EmbedThumbnailOriginal,
  EmbedVideo as EmbedVideoOriginal,
  PostTranslation as PostTranslationOriginal,
  PostCategoriesUpdated as PostCategoriesUpdatedOriginal,
  PostTagsUpdated as PostTagsUpdatedOriginal,
  ScheduledPostPublished as ScheduledPostPublishedOriginal,
  PostLiked as PostLikedOriginal,
  PostLikedInitiatorOneOf as PostLikedInitiatorOneOfOriginal,
  PostUnliked as PostUnlikedOriginal,
  PostUnlikedInitiatorOneOf as PostUnlikedInitiatorOneOfOriginal,
  ListTemplatesRequest as ListTemplatesRequestOriginal,
  GetPostTemplatesSort as GetPostTemplatesSortOriginal,
  GetPostTemplatesSortWithLiterals as GetPostTemplatesSortWithLiteralsOriginal,
  BlogPaging as BlogPagingOriginal,
  ListTemplatesResponse as ListTemplatesResponseOriginal,
  MetaData as MetaDataOriginal,
  Category as CategoryOriginal,
  CategoryTranslation as CategoryTranslationOriginal,
  GetTemplateRequest as GetTemplateRequestOriginal,
  GetTemplateResponse as GetTemplateResponseOriginal,
  CreateDraftPostFromTemplateRequest as CreateDraftPostFromTemplateRequestOriginal,
  CreateDraftPostFromTemplateResponse as CreateDraftPostFromTemplateResponseOriginal,
  DraftPost as DraftPostOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  DraftPostTranslation as DraftPostTranslationOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  QueryPublicationsCountStatsRequest as QueryPublicationsCountStatsRequestOriginal,
  QueryPublicationsCountStatsRequestOrder as QueryPublicationsCountStatsRequestOrderOriginal,
  QueryPublicationsCountStatsRequestOrderWithLiterals as QueryPublicationsCountStatsRequestOrderWithLiteralsOriginal,
  QueryPublicationsCountStatsResponse as QueryPublicationsCountStatsResponseOriginal,
  PeriodPublicationsCount as PeriodPublicationsCountOriginal,
  QueryPostCountStatsRequest as QueryPostCountStatsRequestOriginal,
  Order as OrderOriginal,
  OrderWithLiterals as OrderWithLiteralsOriginal,
  QueryPostCountStatsResponse as QueryPostCountStatsResponseOriginal,
  PeriodPostCount as PeriodPostCountOriginal,
  GetTotalPublicationsRequest as GetTotalPublicationsRequestOriginal,
  GetTotalPublicationsResponse as GetTotalPublicationsResponseOriginal,
  GetTotalPostsRequest as GetTotalPostsRequestOriginal,
  GetTotalPostsResponse as GetTotalPostsResponseOriginal,
  GetTotalLikesPerMemberRequest as GetTotalLikesPerMemberRequestOriginal,
  GetTotalLikesPerMemberResponse as GetTotalLikesPerMemberResponseOriginal,
  PostCountersUpdated as PostCountersUpdatedOriginal,
  PostCountersUpdatedInitiatorOneOf as PostCountersUpdatedInitiatorOneOfOriginal,
  Field as FieldOriginal,
  FieldWithLiterals as FieldWithLiteralsOriginal,
  PostOwnerChanged as PostOwnerChangedOriginal,
  InitialPostsCopied as InitialPostsCopiedOriginal,
  GetPostRequest as GetPostRequestOriginal,
  PostFieldField as PostFieldFieldOriginal,
  PostFieldFieldWithLiterals as PostFieldFieldWithLiteralsOriginal,
  GetPostResponse as GetPostResponseOriginal,
  GetPostBySlugRequest as GetPostBySlugRequestOriginal,
  GetPostBySlugResponse as GetPostBySlugResponseOriginal,
  ListPostsRequest as ListPostsRequestOriginal,
  GetPostsSort as GetPostsSortOriginal,
  GetPostsSortWithLiterals as GetPostsSortWithLiteralsOriginal,
  ListPostsResponse as ListPostsResponseOriginal,
  QueryPostsRequest as QueryPostsRequestOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  PlatformQuery as PlatformQueryOriginal,
  PlatformQueryPagingMethodOneOf as PlatformQueryPagingMethodOneOfOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPostsResponse as QueryPostsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  GetPostMetricsRequest as GetPostMetricsRequestOriginal,
  GetPostMetricsResponse as GetPostMetricsResponseOriginal,
  ViewPostRequest as ViewPostRequestOriginal,
  ViewPostResponse as ViewPostResponseOriginal,
  LikePostRequest as LikePostRequestOriginal,
  LikePostResponse as LikePostResponseOriginal,
  UnlikePostRequest as UnlikePostRequestOriginal,
  UnlikePostResponse as UnlikePostResponseOriginal,
  PinPostRequest as PinPostRequestOriginal,
  PinPostResponse as PinPostResponseOriginal,
  UnpinPostRequest as UnpinPostRequestOriginal,
  UnpinPostResponse as UnpinPostResponseOriginal,
  ListPostsArchiveRequest as ListPostsArchiveRequestOriginal,
  ListPostsArchiveResponse as ListPostsArchiveResponseOriginal,
  GetPostCountPerMonthRequest as GetPostCountPerMonthRequestOriginal,
  GetPostCountPerMonthResponse as GetPostCountPerMonthResponseOriginal,
  PostCountPerMonth as PostCountPerMonthOriginal,
  BulkGetPostReactionsRequest as BulkGetPostReactionsRequestOriginal,
  BulkGetPostReactionsResponse as BulkGetPostReactionsResponseOriginal,
  Reactions as ReactionsOriginal,
  DeletePostRequest as DeletePostRequestOriginal,
  DeletePostResponse as DeletePostResponseOriginal,
  BulkDeletePostsRequest as BulkDeletePostsRequestOriginal,
  BulkDeletePostsResponse as BulkDeletePostsResponseOriginal,
  GetPostCountsRequest as GetPostCountsRequestOriginal,
  GetPostCountsResponse as GetPostCountsResponseOriginal,
  PostCount as PostCountOriginal,
  ListDemoPostsRequest as ListDemoPostsRequestOriginal,
  ListDemoPostsResponse as ListDemoPostsResponseOriginal,
  ConvertDraftJsToRichContentRequest as ConvertDraftJsToRichContentRequestOriginal,
  ConvertDraftJsToRichContentResponse as ConvertDraftJsToRichContentResponseOriginal,
  ConvertRichContentToDraftJsRequest as ConvertRichContentToDraftJsRequestOriginal,
  ConvertRichContentToDraftJsResponse as ConvertRichContentToDraftJsResponseOriginal,
} from './blog-v3-post-posts.types.js';
